import React from "react";
import { Header } from "@/components/layout/Header";
import { Footer } from "@/components/layout/Footer";

// Page shell: header + footer + a hero band for inner pages
export const PageShell = ({ children }) => (
  <div className="flex min-h-screen flex-col bg-gmoaa-cream">
    <Header />
    <main className="flex-1">{children}</main>
    <Footer />
  </div>
);

export const PageHero = ({ title, subtitle }) => (
  <div className="border-b border-gmoaa-border-subtle bg-gmoaa-green-light">
    <div className="gmoaa-container py-10 sm:py-14">
      <div className="mb-3 h-1 w-12 rounded-full bg-gmoaa-saffron" />
      <h1 className="font-serif text-3xl font-bold text-gmoaa-green sm:text-4xl">{title}</h1>
      {subtitle && <p className="mt-2 max-w-2xl text-sm text-gmoaa-text-muted sm:text-base">{subtitle}</p>}
    </div>
  </div>
);
